import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import { componentUtils } from '@mtfe/sweet-components';
import TabsPane from '@mtfe/sweet-components/common/TabsPane/script';

import tpl from './dom.html';
import style from './style.less';
import store, { storeRecallBizIdMap } from '../../store';
import PoiListWithTabs from '../PoiListWithTabs/script';
import { renderPoiInfoGWithCoupon } from '../../utils/renderPoi';
import CrazyPoiList from '../CrazyPoiList/script';

const { storeCommon } = store;
const { createUniqueId, throttle } = common;
const { getOnClickEventName } = componentUtils;
const leftBtnId = createUniqueId();
const rightBtnId = createUniqueId();
const tabNavId = createUniqueId();
const tipsId = createUniqueId();

let selfIsShowOnce = false;

const onSticky = () => {
    const tabNavDom = dom.$id(tabNavId);
    const { top } = tabNavDom.getBoundingClientRect();
    if (Math.abs(top) <= 1) {
        return;
    }
    const currentVw = window.screen.width / 100;
    const maxTop = currentVw * 10.667;
    // 适配手机端的情况，手机端top值不稳定
    if (top <= maxTop || Math.abs(top - maxTop) <= 1) {
        tabNavDom.classList.add(style.tabsNavCeiling);
    } else {
        tabNavDom.classList.remove(style.tabsNavCeiling);
    }
};
const SelfTabReady = (defaultActiveTab) => {
    eventBus.$onceOn('SelfTabReady', () => {
        document.addEventListener('scroll', throttle(onSticky, 200));
        eventBus.$emit(getOnClickEventName(defaultActiveTab));
        eventBus.$emit('RegularPoi');
    });
};
const SelfTab = () => {
    const { dom_wm_big_coupon_left: domCrazyCoupon } = storeCommon.structInfo.struct;
    const storeCrazyCoupon = store[domCrazyCoupon.recallBizId];
    const storeSelfCoupon = store[storeRecallBizIdMap.wmSelfCoupon];
    const defaultActiveTab = storeCrazyCoupon.recallBizId;

    const poiListWithTabs = new PoiListWithTabs({
        targetStore: store[storeRecallBizIdMap.wmSelfCoupon],
        renderFunc: renderPoiInfoGWithCoupon,
        isSticky: true,
    });
    const crazyPoiListActive = () => {
        const leftBtnDom = dom.$id(leftBtnId);
        const rightBtnDom = dom.$id(rightBtnId);
        const crazyDom = dom.$id(storeCrazyCoupon.tabsContainerID);
        const selfDom = dom.$id(storeSelfCoupon.tabsContainerID);

        leftBtnDom.classList.add(style.crazyActiveStyle);
        rightBtnDom.classList.remove(style.selfActiveStyle);
        crazyDom.style.display = '';
        selfDom.style.display = 'none';
        poiListWithTabs.onSticky();
    };
    const selfPoiListActive = () => {
        const leftBtnDom = dom.$id(leftBtnId);
        const rightBtnDom = dom.$id(rightBtnId);
        const crazyDom = dom.$id(storeCrazyCoupon.tabsContainerID);
        const selfDom = dom.$id(storeSelfCoupon.tabsContainerID);

        leftBtnDom.classList.remove(style.crazyActiveStyle);
        rightBtnDom.classList.add(style.selfActiveStyle);
        crazyDom.style.display = 'none';
        selfDom.style.display = '';
        poiListWithTabs.onSticky();
    };

    const crazyPoiListDom = CrazyPoiList();
    const data = {
        leftTabsKey: storeCrazyCoupon.recallBizId,
        rightTabsKey: storeSelfCoupon.recallBizId,
        leftBtnId,
        rightBtnId,
        tabNavId,
        tipsId,
        leftComponent: TabsPane({
            tabContainerID: storeCrazyCoupon.tabsContainerID,
            innerComponent: crazyPoiListDom,
            defaultDisplay: defaultActiveTab === storeCrazyCoupon.recallBizId,
        }),
        rightComponent: TabsPane({
            tabContainerID: storeSelfCoupon.tabsContainerID,
            innerComponent: poiListWithTabs.getComponent(),
            defaultDisplay: defaultActiveTab === storeSelfCoupon.recallBizId,
        }),
        leftRecvNum: storeCommon.leftRecvNum,
    };
    if (defaultActiveTab === storeCrazyCoupon.recallBizId) {
        data.crazyActiveStyle = style.crazyActiveStyle;
    } else {
        data.selfActiveStyle = style.selfActiveStyle;
    }
    const events = {
        onClickTabs: async (key) => {
            if (key === storeCrazyCoupon.recallBizId) {
                crazyPoiListActive();
            } else if (key === storeSelfCoupon.recallBizId) {
                selfPoiListActive();
                if (!selfIsShowOnce) {
                    poiListWithTabs.ready();
                    selfIsShowOnce = true;
                }
            }
        },
    };
    SelfTabReady(defaultActiveTab);
    eventBus.$on('selfCoupon-changeTimes', (times) => {
        const subtitleDom = dom.$id(tipsId);
        if (subtitleDom) {
            subtitleDom.innerHTML = `可选<span>${times}</span>次`;
        }
    });
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default SelfTab;
